"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAVORITES_DIALOG = void 0;
const FAVORITES_DIALOG = exports.FAVORITES_DIALOG = 'favorites-dialog';
